import { Circle } from './styles'

const AddButton = () => <Circle to="/new-contact">+</Circle>

export default AddButton
